import {
    Button,
    Grid,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
    Box,
} from '@mui/material'
import React, { useEffect, useState } from 'react'

import {
    Check,
    Close,
    ContentCopyOutlined,
    RadioButtonChecked,
    RadioButtonUnchecked,
} from '@mui/icons-material'
import TinyMceEditor from '../Common/TinyMceEditor'
import { RestApi } from '../../RestApi'
import { Modal } from 'antd'
import GLOBAL from '../../Globals'
import { makeStyles } from 'tss-react/mui'

const MCQQuestionDetailsModalNew = ({
    open = false,
    closeQuestionDetailsModal = () => {},
    questionId = 0,
    reportType = '',
    autoId = '',
    isCloseTab = false,
    updateAndCloseQuestion,
}) => {
    const { classes } = useStyles()
    const [questionData, setQuestionData] = useState({})
    const [loading, setLoading] = useState(false)
    const [plainQuestion, setPlainQuestion] = useState('')
    const [htmlQuestion, setHtmlQuestion] = useState('')
    const [errorMsg, setErrorMsg] = useState('')
    const [copyOpen, setCopyOpen] = useState(false)
    const [showUpdateQuestionDetailsModal, setShowUpdateQuestionDetailsModal] =
        useState(false)
    const [recordOptionTextData, setRecordOptionTextData] = useState([])
    const [feedbackTextInput, setFeedbackTextInput] = useState('')
    const [feedbackTextInputHTML, setFeedbackTextInputHTML] = useState('')
    const [updateComment, setUpdateComment] = useState('')

    useEffect(() => {
        if (open) {
            getTestsQuestionData()
        }
        // eslint-disable-next-line
    }, [open])

    const getTestsQuestionData = () => {
        if (!questionId) return
        setLoading(true)
        RestApi.doGet(GLOBAL.URL.FLAGGED_MCQS.GET_QUESTION_DETAILS + questionId)
            .then((resp) => {
                const response = resp.data
                setQuestionData(response)
                if (response.plainText) {
                    setPlainQuestion(response.question)
                } else {
                    setHtmlQuestion(response.question)
                }
                const optionsData = response.options.map((record) => ({
                    option: record.option,
                    optionId: record.id,
                    isCorrect: record.correct,
                }))
                setRecordOptionTextData(optionsData)

                if (response.feedbackPlainText) {
                    setFeedbackTextInput(response.feedback)
                } else {
                    setFeedbackTextInputHTML(response.feedback)
                }
            })
            .finally(() => setLoading(false))
    }

    const onPlainQuestionChange = (e) => {
        setPlainQuestion(e.target.value)
        setErrorMsg('')
    }

    const handleEditorChange = (newValue, e) => {
        setHtmlQuestion(newValue)
    }

    const openUpdateQuestionDetailsModal = () => {
        setShowUpdateQuestionDetailsModal(true)
    }

    const closeUpdateQuestionDetailsModal = () => {
        setShowUpdateQuestionDetailsModal(false)
        setUpdateComment('')
        setErrorMsg('')
    }

    const handleFeedBackEditorChange = (newValue, e) => {
        setFeedbackTextInputHTML(newValue)
    }

    const closeMCQFlag = () => {
        if (!autoId) {
            return
        } else if (!questionId) {
            return
        } else if (!updateComment) {
            setErrorMsg('Please add Comment')
            return
        }
        setLoading(true)

        const payload = {
            autoId: autoId,
            questionId: questionId,
            question: questionData.plainText ? plainQuestion : htmlQuestion,
            feedback: questionData.feedbackPlainText
                ? feedbackTextInput
                : feedbackTextInputHTML,
            options: recordOptionTextData,
            comments: updateComment,
        }
        const formbody = new FormData()
        formbody.append('payload', JSON.stringify(payload))

        RestApi.doPost(GLOBAL.URL.FLAGGED_MCQS.CLOSE_MCQ_FLAG, formbody)
            .then((response) => {
                closeUpdateQuestionDetailsModal()
                closeQuestionDetailsModal()
                updateAndCloseQuestion()
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const onRadioBtnClick = (index) => {
        setRecordOptionTextData((prevState) => {
            const updatedState = prevState.map((option, i) => ({
                ...option,
                isCorrect: i === index,
            }))
            return updatedState
        })
    }

    const onOptionTextChange = (event, index) => {
        const updatedValue = event.target.value
        setRecordOptionTextData((prevState) => {
            const updatedState = [...prevState]
            updatedState[index] = {
                ...updatedState[index],
                option: updatedValue,
            }
            return updatedState
        })
    }

    return (
        <Grid>
            <Modal
                width={800}
                open={open}
                onCancel={closeQuestionDetailsModal}
                destroyOnClose={true}
                footer={null}
            >
                <Grid style={{ padding: '20px 30px' }}>
                    <Grid className={classes.titleContainer}>
                        <Grid className={classes.titleWrapper}>
                            <Typography
                                style={{ fontSize: 18, fontWeight: 900 }}
                            >
                                MCQ - {questionId}
                            </Typography>

                            <Tooltip
                                PopperProps={{
                                    disablePortal: true,
                                }}
                                onClose={() => {
                                    setCopyOpen(false)
                                }}
                                open={copyOpen}
                                title="Link Copied"
                                arrow
                            >
                                <ContentCopyOutlined
                                    className={classes.linkButton}
                                    onClick={() => {
                                        navigator.clipboard.writeText(
                                            `https://admin.indigolearn.com/mcq/questiondetails/${questionId}`
                                        )
                                        setCopyOpen(true)
                                    }}
                                />
                            </Tooltip>

                            {!isCloseTab ? (
                                <Button
                                    variant="contained"
                                    className={classes.closedBtn}
                                    onClick={openUpdateQuestionDetailsModal}
                                >
                                    Update & Close
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>

                    {!loading ? (
                        Object.keys(questionData).length > 0 ? (
                            <Grid>
                                <Typography style={{ fontSize: 14 }}>
                                    Subject:
                                </Typography>
                                <Typography
                                    style={{ fontSize: 14, marginBottom: 15 }}
                                >
                                    <strong>{questionData.subjectName}</strong>
                                </Typography>

                                <Typography style={{ fontSize: 14 }}>
                                    ReportType:
                                </Typography>
                                <Typography
                                    style={{ fontSize: 14, marginBottom: 20 }}
                                >
                                    <strong>{reportType}</strong>
                                </Typography>

                                <Box className={classes.updateContainer}>
                                    <Typography className={classes.updateText}>
                                        Question:
                                    </Typography>
                                </Box>

                                <Typography className={classes.questionWrapper}>
                                    {questionData.plainText ? (
                                        questionData.question
                                    ) : (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: questionData.question,
                                            }}
                                        />
                                    )}
                                </Typography>

                                <Box className={classes.updateContainer}>
                                    <Typography className={classes.updateText}>
                                        Feedback:
                                    </Typography>
                                </Box>

                                <Typography className={classes.questionWrapper}>
                                    {questionData.feedback ? (
                                        <>
                                            {questionData.feedbackPlainText ? (
                                                questionData.feedback
                                            ) : (
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: questionData.feedback,
                                                    }}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        'No Feedback'
                                    )}
                                </Typography>
                                <TableContainer style={{ borderRadius: 3 }}>
                                    <Table
                                        style={{
                                            border: '1px solid rgba(224, 224, 224, 1)',
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    className={
                                                        classes.correctCell
                                                    }
                                                >
                                                    Correct
                                                </TableCell>
                                                <TableCell
                                                    className={classes.options}
                                                    sx={{
                                                        background: '#f1f8fe',
                                                    }}
                                                >
                                                    Option
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {questionData.options.map(
                                                (record, index) => {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell
                                                                className={
                                                                    classes.date
                                                                }
                                                            >
                                                                <span>
                                                                    {!record.correct ? (
                                                                        <Close
                                                                            className={
                                                                                classes.closeModalIcon
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <Check
                                                                            className={
                                                                                classes.checkModalIcon
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                            </TableCell>

                                                            <TableCell
                                                                className={
                                                                    classes.options
                                                                }
                                                            >
                                                                <Box
                                                                    className={
                                                                        classes.updateContainer
                                                                    }
                                                                >
                                                                    <Typography>
                                                                        {
                                                                            record.option
                                                                        }
                                                                    </Typography>
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        ) : null
                    ) : (
                        <Grid className={classes.internalContainer}>
                            <Skeleton height={'235px'} />
                            <Skeleton width={'65%'} height={150} />
                            <Skeleton width={'65%'} height={150} />
                        </Grid>
                    )}
                </Grid>
            </Modal>

            <Modal
                title={'Update Question Details'}
                open={showUpdateQuestionDetailsModal}
                onCancel={closeUpdateQuestionDetailsModal}
                onOk={closeMCQFlag}
                okText="Update & Close"
                confirmLoading={loading}
                destroyOnClose={true}
                width={800}
            >
                <Typography
                    className={classes.updateText}
                    sx={{ marginBottom: '10px' }}
                >
                    Question:
                </Typography>

                {questionData.plainText ? (
                    <TextField
                        variant={'outlined'}
                        size="small"
                        className={classes.textField}
                        value={plainQuestion}
                        onChange={(event) => {
                            onPlainQuestionChange(event)
                        }}
                        minRows={1}
                    />
                ) : (
                    <TinyMceEditor
                        height={300}
                        handleEditorChange={handleEditorChange}
                        initialValue={htmlQuestion}
                    />
                )}

                <Grid style={{ borderRadius: 3, margin: '30px 0px 30px 10px' }}>
                    <Box>
                        <Box className={classes.optionHeading}>
                            <Typography
                                style={{ fontWeight: 'bold', fontSize: 14 }}
                            >
                                Correct
                            </Typography>
                            <Typography
                                style={{ fontWeight: 'bold', fontSize: 14 }}
                            >
                                Options
                            </Typography>
                        </Box>

                        {questionData?.options?.map((_, index) => {
                            return (
                                <Box
                                    key={index}
                                    className={classes.optionRecordData}
                                >
                                    <Box style={{ marginLeft: 0 }}>
                                        <Box
                                            style={{
                                                cursor: 'pointer',
                                                marginLeft: 20,
                                            }}
                                        >
                                            {recordOptionTextData[index]
                                                .isCorrect ? (
                                                <RadioButtonChecked
                                                    className={
                                                        classes.checkModalIcon
                                                    }
                                                />
                                            ) : (
                                                <RadioButtonUnchecked
                                                    className={
                                                        classes.closeModalIcon
                                                    }
                                                    style={{ color: '#e5e5e5' }}
                                                    onClick={() =>
                                                        onRadioBtnClick(index)
                                                    }
                                                />
                                            )}
                                        </Box>
                                    </Box>

                                    <Box className={classes.options}>
                                        <TextField
                                            variant={'outlined'}
                                            size="small"
                                            className={classes.textField}
                                            value={
                                                recordOptionTextData[index]
                                                    ?.option
                                            }
                                            onChange={(event) =>
                                                onOptionTextChange(event, index)
                                            }
                                            minRows={1}
                                        />
                                    </Box>
                                </Box>
                            )
                        })}
                    </Box>
                </Grid>

                <Box
                    className={classes.updateContainer}
                    sx={{ marginBottom: '10px' }}
                >
                    <Typography className={classes.updateText}>
                        Feedback:
                    </Typography>
                </Box>

                {questionData.feedbackPlainText ? (
                    <TextField
                        variant={'outlined'}
                        size="small"
                        className={classes.textField}
                        value={feedbackTextInput}
                        onChange={(event) => {
                            setErrorMsg('')
                            setFeedbackTextInput(event.target.value)
                        }}
                        minRows={1}
                    />
                ) : (
                    <TinyMceEditor
                        height={300}
                        handleEditorChange={handleFeedBackEditorChange}
                        initialValue={feedbackTextInputHTML}
                    />
                )}

                <Box
                    className={classes.updateContainer}
                    sx={{ margin: '20px 0px 10px' }}
                >
                    <Typography className={classes.updateText}>
                        Comment:{' '}
                    </Typography>
                </Box>

                <TextField
                    variant={'outlined'}
                    size="small"
                    className={classes.textField}
                    value={updateComment}
                    onChange={(event) => {
                        setErrorMsg('')
                        setUpdateComment(event.target.value)
                    }}
                    minRows={1}
                />

                {errorMsg && (
                    <Typography
                        style={{ color: 'red', fontSize: 13, marginTop: 10 }}
                    >
                        {errorMsg}
                    </Typography>
                )}
            </Modal>
        </Grid>
    )
}

export default MCQQuestionDetailsModalNew

const useStyles = makeStyles()((theme) => ({
    internalContainer: {
        width: '100%',
        marginRight: 20,
    },
    updateContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        width: 'fit-content',
    },

    updateText: {
        fontSize: '15px',
        fontWeight: 900,
    },
    textField: {
        '& textarea': {
            minHeight: '20px',
        },
        width: '100%',
        '& .MuiOutlinedInput-inputMarginDense': {
            padding: '8px 14px',
            fontSize: 10,
        },
    },

    questionWrapper: {
        fontSize: 14,
        marginLeft: 0,
        marginBottom: 20,
    },
    correctCell: {
        width: 100,
        background: '#f1f8fe',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    closeModalIcon: {
        color: 'red',
        fontSize: 18,
        [theme.breakpoints.down('md')]: {
            fontSize: 14,
        },
    },
    checkModalIcon: {
        color: '#1677ff',
        fontSize: 18,
        [theme.breakpoints.down('md')]: {
            fontSize: 14,
        },
    },
    cnfDialogTitle: {
        fontSize: 15,
        textAlign: 'center',
    },
    customTitleWrapper: {
        display: 'block',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 25,
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    linkButton: {
        color: '#1677ff',
        fontSize: 15,
        cursor: 'pointer',
    },
    options: {
        minWidth: 200,
        flex: 1,
    },
    closeBtn: {
        marginRight: -10,
    },
    closedBtn: {
        textTransform: 'capitalize',
        padding: '3px 6px',
        borderRadius: 5,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
            fontSize: 13,
        },
    },
    modalBtnWrapper: {
        marginTop: '20px',
        justifyContent: 'flex-start',
    },
    optionHeading: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
        gap: 15,
    },
    optionRecordData: {
        display: 'flex',
        alignItems: 'center',
        gap: '3%',
        marginBottom: '5px',
    },
    date: {
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
}))
